// import { mmenuStarter } from './mmenu.js';
import $ from 'jquery';
import { aos } from './main/aos.js';
import { mmenuStarter } from './main/mmenu.js';
import { lazyLoad } from './main/lazyload.js'
import { slider } from './main/slider.js';
import { faq } from './main/faq.js';
import { moreDropdown } from './main/more_dropdown';
import { bioShow } from './main/bioShow.js';
import AOS from 'aos';
import { toggleMenu } from './main/toggleMenu.js';
// import {caseStudyGallery} from './main/caseStudyGallery'


$(function() {
	// Handler for .ready() called.
	new mmenuStarter();
	new aos();
	new lazyLoad();
	new slider();
	new faq();
	new moreDropdown();
	new bioShow();
	new toggleMenu();
	// new caseStudyGallery();
	
	
	AOS.refresh();

});